// extracted by mini-css-extract-plugin
module.exports = {"box":"Item_box__2EiY3","line":"Item_line__LTVf6","progress":"Item_progress__B6wk5","counter":"Item_counter__13Uzx","balance":"Item_balance__1U1Cv"};